import type { createToastInterface } from 'vue-toastification';
import type { ToastVariant } from '@zotlo-shared/components/toast/index.vue';

export function showToast(title: string, subtitle: string, variant: ToastVariant, options?: Parameters<typeof createToastInterface>[0]) {
  if (!import.meta.client) return () => ({});
  const { $toast } = useNuxtApp();
  ($toast as any).showToast(title, subtitle, variant, options);
}

export function clearToasts() {
  if (!import.meta.client) return () => ({});
  const { $toast } = useNuxtApp();
  ($toast as any).clearToasts();
}
